import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import { VerifyEnterpriseInfoResponse } from '../interfaces/verify-enterprise.model';
@Injectable({
  providedIn: 'root',
})
export class VerifyEnterpriseService {
  http: HttpClient = inject(HttpClient);


  /**
   * 驗證企業資訊(CB-040)
   * @param companyNo 企業代碼
   */
  verifyEnterpriseInfo(
    companyNo: string
  ): Observable<ApiResponse<VerifyEnterpriseInfoResponse>> {
    const payload = { companyNo };
    return this.http.post<ApiResponse<VerifyEnterpriseInfoResponse>>(
      API_ENDPOINTS.VERIFY_ENTERPRISE_INFO,
      payload
    );
  }
}
